
import Page from 'Scripts/classes/Page'

export default class extends Page {
  constructor() {
    super(
      'carriere',
      {
        container: '.carriere',
        elements: {
          paginationLink: '.module__btn_readmore a',
          moduleWrapper: '.module__wrapper'
        }
      })


  }

  /**
  * Animations.
  */
  show() {
    return super.show()
  }

  hide() {
    return super.hide()
  }

  onResize() {
    // console.log('onResize')
    return super.onResize()
  }
}

